<template>
  <el-tree
    ref="tree"
    :data="treeData"
    :node-key="nodeKey"
    show-checkbox
    expand-on-click-node
    :default-checked-keys="defaultCheckedKeys"
    :default-expand-all="expandAll"
    highlight-current
    :props="defaultProps"
    @check="getKeys"
  >
    <span
      slot-scope="{ node, data }"
      class="custom-tree-node">
      <span>{{ node.label }}</span>
      <template v-if="data.operations && data.operations.length > 0 ">
        <el-checkbox-group v-model="operationsNew[data.funcId]">
          <el-checkbox
            v-for="item in data.operations"
            :key="item.operation"
            :label="item.operation">{{ map[item.operation] }}</el-checkbox>
        </el-checkbox-group>
      </template>
    </span>
  </el-tree>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'CheckboxTree',
  components: {},
  props: {
    operations: {
      type: Object,
      default() {
        return {}
      }
    },
    expandAll: {
      type: Boolean,
      default: true
    },
    treeData: {
      type: Array,
      default() {
        return []
      }
    },
    nodeKey: {
      type: String,
      default: 'id'
    },
    value: {
      type: Array,
      default() {
        return []
      }
    },
    defaultProps: {
      type: Object,
      default() {
        return {
          children: 'children',
          label: 'label'
        }
      }
    }
  },
  data() {
    return {
      map: {
        'mobile_sampling': '移动抽样',
        'assign': '分配',
        'accept': '受理'
      }
    }
  },
  computed: {
    operationsNew: {
      get() {
        return this.operations
      },
      set(val) {
        console.log('---------------------------------', val)
        this.$emit('change', val)
      }
    },
    defaultCheckedKeys: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    disabled() {
      return this.defaultCheckedKeys.indexOf(135) === -1
    },
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  // watch: {
  //   defaultCheckedKeys(val) {
  //     if (val.indexOf(135) === -1) {
  //       // console.log('reset')
  //       this.$emit('reset')
  //     }
  //   }
  // },
  methods: {
    test11(node) {
      console.log(node)
    },
    change(e) {
      console.log(e)
      this.$emit('change', e)
    },
    getKeys(data, checked) {
      console.log('getKeys--------------------')
      this.defaultCheckedKeys = checked.checkedKeys
    },
    getCheckedNodes() {
      return this.$refs.tree.getCheckedNodes()
    }
  }
}
</script>
<style lang="stylus">
.custom-tree-node {
   flex: 1;
   display: flex;
   align-items: center;
   justify-content: space-between;
   font-size: 14px;
   padding-right: 8px;
 }
</style>
